module.exports = __webpack_public_path__ + "img/Nei Mongol-power.26849dc7.png";